'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { styled } from 'styled-components';
import { getFontSize } from '../../abstracts';
import { StoreBlockContext } from './StoreBlockContext';
import { Hours, HoursWrapper, HoursToggle } from './Hours';
import { DefaultsProvider, separateChildrenByType } from '../../util';
const StyledDetail = styled.div.withConfig({
  componentId: "aui__sc-3pq1ui-0"
})(["display:flex;flex-direction:row;align-items:flex-start;gap:var(--aui-spacing-100);font-size:", ";line-height:", ";> [data-aui='icon']{flex-shrink:0;}[data-aui='tag']{margin-top:", ";}"], ({
  $fontSize
}) => getFontSize($fontSize), ({
  $lineHeight
}) => $lineHeight, ({
  $tagOffset
}) => $tagOffset);
export const Detail = ({
  children,
  ...props
}) => {
  const {
    size
  } = useContext(StoreBlockContext);
  const fontSize = {
    sm: 2,
    lg: 2,
    xl: 3
  }[size];
  const lineHeight = {
    sm: '1.5rem',
    lg: '1.5rem',
    xl: '2rem'
  }[size];
  const iconSize = {
    sm: 'large',
    lg: 'large',
    xl: 'xlarge'
  }[size];
  const tagOffset = {
    sm: '0',
    lg: '0',
    xl: 'var(--aui-spacing-050)'
  }[size];
  const [hours, others] = separateChildrenByType(children, Hours);
  const showHours = hours.length > 0;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const contentRef = React.useRef(null);
  const contentHeight = isExpanded ? contentRef.current.scrollHeight : 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledDetail, _extends({}, props, {
    $fontSize: fontSize,
    $lineHeight: lineHeight,
    $tagOffset: tagOffset
  }), /*#__PURE__*/React.createElement(DefaultsProvider, {
    value: {
      iconSize,
      iconFill: 'inherit',
      tagSize: 'large'
    }
  }, others), showHours && /*#__PURE__*/React.createElement(HoursToggle, {
    onClick: () => setIsExpanded(!isExpanded),
    isRotated: isExpanded,
    size: size
  })), showHours && /*#__PURE__*/React.createElement(HoursWrapper, {
    ref: contentRef,
    maxHeight: contentHeight
  }, hours));
};